import React from 'react';
import { CDN_BASE_URL } from '../shared';

/**
 * Platform — showcases the in-house steering software. Editorial style, matches
 * Methodology/Benefits. Auto-numbered inside `.numbered-sections`.
 *
 * Image: upload a crisp 2× export of the dashboard to the Spaces CDN (public-read)
 * as `dashboard-preview.png`, or change DASHBOARD_IMG below. It sits between the
 * light "Vorteile" section and the dark "Fallstudien" section.
 *
 * Two exports: the wide desktop screenshot is unreadable once it is scaled into
 * a phone-width column, so a separate portrait crop is served below 720px (the
 * page's mobile breakpoint). <picture> picks one — the browser downloads only
 * the matching source, never both.
 */
const DASHBOARD_IMG = `${CDN_BASE_URL}/dashboard-preview.png`;
const DASHBOARD_IMG_MOBILE = `${CDN_BASE_URL}/dashboard-preview-mobile.png`;

export default function Platform() {
  const features = [
    {
      title: 'Zahlungsströme & Überschüsse',
      body:
        'Von der Mieteinnahme bis zum tatsächlichen Ergebnis. Jede Position monatlich aufgeschlüsselt und nachvollziehbar.',
    },
    {
      title: 'Belegung & Leerstand',
      body:
        'Belegungsrate, Leerstandskosten und Neuvermietung auf einen Blick.',
    },
    {
      title: 'Betriebskosten',
      body:
        'Umlagefähig oder nicht — jede Kostenposition transparent.',
    },
    {
      title: 'Mahnwesen',
      body:
        'Automatisiertes Forderungsmanagement, das Rückstände erkennt und konsequent eintreibt.',
    },
  ];

  return (
    <section style={{ padding: '140px 0', background: 'var(--cream-deep)' }}>
      <div className="shell">
        <div className="section-label numbered reveal" style={{ marginBottom: 28 }}>
          <span>Unsere Technologie</span>
        </div>
        <h2 className="h-section reveal" style={{ marginBottom: 26 }}>
          Intelligente Steuerung Ihrer Immobilien.
        </h2>
        {/* Dashboard screenshot — clean editorial frame */}
        <div
          className="reveal"
          style={{
            border: '1px solid var(--cream-line)',
            borderRadius: 8,
            overflow: 'hidden',
            background: 'var(--cream)',
            boxShadow: '0 30px 60px -24px rgba(26,29,36,0.22), 0 8px 22px -14px rgba(26,29,36,0.12)',
          }}
        >
          <picture>
            <source media="(max-width: 720px)" srcSet={DASHBOARD_IMG_MOBILE} />
            <img
              src={DASHBOARD_IMG}
              alt="hamba Steuerungs-Dashboard: NOI, Belegung, Betriebskosten und Mahnwesen eines Objekts auf einen Blick."
              loading="lazy"
              style={{ display: 'block', width: '100%', height: 'auto' }}
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          </picture>
        </div>

        {/* Feature callouts */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 36,
            marginTop: 64,
          }}
        >
          {features.map((f, i) => (
            <div
              key={i}
              className="reveal"
              style={{ borderTop: '1px solid var(--cream-line)', paddingTop: 24 }}
            >
              <h3 className="h-pillar" style={{ fontSize: 18, marginBottom: 10 }}>
                {f.title}
              </h3>
              <p className="body-prose" style={{ fontSize: 15 }}>
                {f.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
